import React from "react";

interface ShowProps {
  children: React.ReactNode;
  when: boolean;
  fallback?: React.ReactNode;
}

const Show = React.memo(({ children, when, fallback = null }: ShowProps) => {
  return when ? children : fallback;
});

Show.displayName = "Show";

export default Show;
